$(document).ready(function () {
	/*
	 * Stateroom Amenities
	 */ 
	//toggle stateroom amenities tabs
	$(document).on('click', '.stateroom-tabs > .button', function (e) {
		e.preventDefault();
		$('.stateroom-tabs > .button').removeClass('active');
		$(this).addClass('active');
		$('.stateroom-panel').hide();
		var stateroomPanel = $(this).index();
		$('.stateroom-panel').eq(stateroomPanel).fadeIn('fast');
	});
	
	//show the first image in the image gallery regarless of which viw larger link is clicked
	$(document).on('click', '.stateroom-view-larger', function(e) {
		e.preventDefault();
		$('.stateroom-tabs > .button').eq(1).trigger('click');
		var target = $(this).closest('.amenity-image').index();
		$('.stateroom-gallery-thumb').eq(target).trigger('click');
	});
	
	/*
	 * Stateroom image gallery
	 */
	//when a thumb is click, update the gallery iframe src
	$(document).on('click', '.stateroom-gallery-thumb', function(e) {
		e.preventDefault();
		var targetThumb = $(this);
		var pos = targetThumb.index();
		var targetSrc = targetThumb.attr('href');
		var targetImg = $('.stateroom-gallery-img').eq(pos);
		
		if (!targetThumb.hasClass('selected')) {
			$('.stateroom-gallery-thumb').removeClass('selected');
			targetThumb.addClass('selected');
			
			if (targetImg.is(':empty')) {
				targetImg.css('min-height',$('.stateroom-gallery-img.active').height());
				$('<img>').on('load',function() {
					targetImg.prepend(this);
					/* No longer needed
					if (typeof targetThumb.find('img').attr('alt') != 'undefined' && targetThumb.find('img').attr('alt') != '') {
						targetImg.append('<h3 class="img-title">' + targetThumb.find('img').attr('alt') + '</h3>');
					}*/
					$('.stateroom-gallery-img').removeClass('active');
					targetImg.addClass('active').removeAttr('style');
				}).attr('src', targetSrc);
			} else {
				$('.stateroom-gallery-img').removeClass('active');
				targetImg.addClass('active');
			}
		}
	});
	
	//select prev or next thumb when using arrow buttons
	$(document).on('click', '.gallery-nav', function(e) {
		e.preventDefault();
		var totalThumb = $('.stateroom-gallery-thumb').length;
		var pos = $('.stateroom-gallery-thumb.selected').index();
		$('.stateroom-gallery-thumb').removeClass('selected');
		if ($(this).hasClass('gallery-next')) {
			if (pos < (totalThumb - 1)) {
				$('.stateroom-gallery-thumb').eq(pos+1).trigger('click');
			} else {
				$('.stateroom-gallery-thumb').eq(0).trigger('click');
			}
		} else {
			if (pos > 0) {
				$('.stateroom-gallery-thumb').eq(pos-1).trigger('click');
			} else {
				$('.stateroom-gallery-thumb').eq(totalThumb-1).trigger('click');
			}
		}
	});
});